import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Tooltip from '@mui/material/Tooltip'
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded'
import { UserContext } from '../../../App'
import { LATEST_WHATS_NEW_VERSION } from '../../../pages/dev/WhatsNew/latestRelease'

const WhatsNewBadge = ({ TaskBadge }) => {
  const { user } = useContext(UserContext)
  const navigate = useNavigate()

  const hasUnseenUpdate =
    !!user?._id &&
    user?.uiPreferences?.whatsNewSeenVersion !== LATEST_WHATS_NEW_VERSION

  if (!hasUnseenUpdate) return null

  return (
    <Tooltip title="What's new">
      <TaskBadge
        variant="dot"
        overlap="circular"
        onClick={() => navigate('/updates')}
        sx={{
          '& .MuiBadge-dot': {
            top: 4,
            right: 4,
            padding: 0,
            boxShadow: '0 0 0 0 rgba(35,154,164,0.6)',
            animation: 'whatsNewPulse 1.8s ease-out infinite',
          },
          '@keyframes whatsNewPulse': {
            '0%': { boxShadow: '0 0 0 0 rgba(35,154,164,0.6)' },
            '70%': { boxShadow: '0 0 0 6px rgba(35,154,164,0)' },
            '100%': { boxShadow: '0 0 0 0 rgba(35,154,164,0)' },
          },
        }}
      >
        <CampaignRoundedIcon sx={{ color: 'primary.main', cursor: 'pointer' }} />
      </TaskBadge>
    </Tooltip>
  )
}

export default WhatsNewBadge
